import script from "./TemplateManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateManager.vue?vue&type=script&setup=true&lang=js"

import "./TemplateManager.vue?vue&type=style&index=0&id=5a6d943f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6d943f"]])

export default __exports__